import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AcessoNegadoComponent } from './acesso-negado/acesso-negado.component';
import { CadastraMaquinaComponent } from './cadastra-maquina/cadastra-maquina.component';
import { ConsultaMaquinaComponent } from './consulta-maquina/consulta-maquina.component';
import { HistoricoMaquinaComponent } from './consulta-maquina/historico-maquina/historico-maquina.component';
import { AlteraEstadoMaquinaComponent } from './altera-estado-maquina/altera-estado-maquina.component'
import { AlteraMaquinaComponent } from './altera-maquina/altera-maquina.component';
import { AcessoNegadoGenericoComponent } from './acesso-negado-generico/acesso-negado-generico.component';

export const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'home', component: HomeComponent},
  {path: 'acesso-negado', component: AcessoNegadoComponent},
  {path: 'acesso-negado-generico', component: AcessoNegadoGenericoComponent},
  {path: 'cadastra-maquina', component: CadastraMaquinaComponent},
  {path: 'consulta-maquina', component: ConsultaMaquinaComponent},
  {path: 'historico-maquina', component: HistoricoMaquinaComponent},
  {path: 'altera-estado-maquina', component: AlteraEstadoMaquinaComponent},
  {path: 'altera-maquina', component: AlteraMaquinaComponent}
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
